import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import CheckoutHome from "./CheckoutHome";
import { I18nProvider } from "@lingui/react";
import "react-notifications/lib/notifications.css";
import { NotificationContainer } from "react-notifications";
import CssBaseline from "@material-ui/core/CssBaseline";
import Products from "./components/products/ProductList";
import EditOrAddProduct from "./components/products/EditOrAddProduct";
import * as serviceWorker from "./serviceWorker";
import * as ROUTES from "./constants/routes";
import SignUpPage from "./components/SignUp";
import SignInPage from "./components/SignIn";
import PasswordForgetPage from "./components/PasswordForget";
import AccountPage from "./components/Account";
import { withAuthentication } from "./components/Session";
import LandingPage from "./components/Landing";
import CustomerCheckout from "./components/CustomerCheckout";
import OrderTracking from "./components/OrderTracking";
import { DeliveryAreasManagement, OrganizationsAdmin } from "./components/Admin";
import { PrivateAdminRoute } from "./components/PrivateRoute";

function App(props) {
  const { language } = props;
  const localeMessage = require(`./locales/${language}/messages.js`);

  useEffect(() => {
    const onServiceWorkerUpdate = (registration) => {
      // Atualização automática - sem notificação ao usuário
      const waitingWorker = registration && registration.waiting;
      if (waitingWorker) {
        waitingWorker.postMessage({ type: "SKIP_WAITING" });
        // Recarregar a página após um pequeno delay para garantir que o novo SW está ativo
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    };

    if (process.env.NODE_ENV === "production") {
      serviceWorker.register({ onUpdate: onServiceWorkerUpdate });
    }
  }, []);

  return (
    <I18nProvider language={language} catalogs={{ [language]: localeMessage }}>
      <CssBaseline />

      <Switch>
        {/* Public Routes - accessible by everyone */}
        <Route exact path={ROUTES.LANDING} component={LandingPage} />
        <Route exact path={ROUTES.CUSTOMER_ORDER} component={CustomerCheckout} />
        <Route exact path="/order-tracking/:organizationId/:orderId" component={OrderTracking} />
        
        {/* Authentication Routes */}
        <Route path={ROUTES.SIGN_UP} component={SignUpPage} />
        <Route
          path={[
            ROUTES.SIGN_IN_ARG,
            ROUTES.SIGN_IN_ARG_PT,
            ROUTES.SIGN_IN,
            ROUTES.SIGN_IN_PT,
          ]}
          component={SignInPage}
        />
        <Route path={ROUTES.PASSWORD_FORGET} component={PasswordForgetPage} />

        {/* Protected Admin Routes - require authentication with AdminLayout */}
        <PrivateAdminRoute exact path={ROUTES.ADMIN_DELIVERY_AREAS} component={DeliveryAreasManagement} />
        <PrivateAdminRoute exact path={ROUTES.ADMIN_ORGANIZATIONS} component={OrganizationsAdmin} />
        <PrivateAdminRoute exact path={[ROUTES.HOME, "/admin/checkout"]} component={CheckoutHome} />
        <PrivateAdminRoute exact path={ROUTES.ADMIN_PRODUCTS} component={Products} />
        <PrivateAdminRoute exact path={ROUTES.ADMIN_PRODUCTS_ADD} component={EditOrAddProduct} />
        <PrivateAdminRoute path={ROUTES.ADMIN_PRODUCTS_EDIT} component={EditOrAddProduct} />
        <PrivateAdminRoute
          path={[ROUTES.ACCOUNT, ROUTES.ACCOUNT_PT]}
          component={AccountPage}
        />
      </Switch>

      <NotificationContainer />
    </I18nProvider>
  );
}

export default withAuthentication(App);
